function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M62.29,180l26.27,291.07C90.7,494.41,109.95,512,133.39,512H378.6c23.44,0,42.69-17.59,44.83-40.93L449.7,180H62.29z  M178.95,451.99c-0.24,0.01-0.47,0.01-0.68,0.01c-7.97,0-14.62-6.27-14.97-14.31l-9.55-212c-0.38-8.28,6.01-15.29,14.3-15.67 c9.37-0.27,15.29,6.05,15.64,14.29l9.55,212C193.62,444.59,187.24,451.61,178.95,451.99z M271,437c0,8.29-6.71,15-15,15 c-8.29,0-15-6.71-15-15V225c0-8.29,6.71-15,15-15c8.29,0,15,6.71,15,15V437z M348.69,437.69c-0.35,8.04-7,14.31-14.97,14.31 c-0.2,0-0.44,0-0.67-0.01c-8.29-0.38-14.68-7.4-14.3-15.68l9.55-212c0.38-8.24,6.33-14.44,15.65-14.29 c8.29,0.38,14.67,7.39,14.29,15.67L348.69,437.69z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M406,60h-45V45c0-24.81-20.19-45-45-45H196c-24.82,0-45,20.19-45,45v15h-45c-41.37,0-75,33.65-75,75v15h450v-15 C481,93.65,447.36,60,406,60z M331,60H181V45c0-8.28,6.73-15,15-15h120c8.26,0,15,6.72,15,15V60z"
})));

var SvgDeletePlaylist = function SvgDeletePlaylist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeletePlaylist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-playlist.b1b5049e.svg";
export { ForwardRef as ReactComponent };